import { render } from "./TheSidebar.vue?vue&type=template&id=48dfd874&scoped=true"
const script = {}

import "./TheSidebar.vue?vue&type=style&index=0&id=48dfd874&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/RJKESzs2/0/roolz/poi-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48dfd874"]])

export default __exports__